import { isWeiXin,appendscript} from './util'
import $ from 'jquery'

const shareConfig = {
    default: {
        wap:{
            title:'\u7528\u597d\u770b\u7684\u804a\u5929\u6c14\u6ce1\u505a\u4eba\u7fa4\u91cc\u7684\u9753\u4ed4',/*用好看的聊天气泡做人群里的靓仔*/
            content:'\u8fd8\u6ca1\u7528\u8fc7\u8fd9\u6b3e\u804a\u5929\u6c14\u6ce1\u4f60\u5c31\u004f\u0055\u0054\u5566\uff01\u4e0b\u8f7d\u641c\u72d7\u8f93\u5165\u6cd5\u9886\u53d6\u66f4\u591a\u514d\u8d39\u6c14\u6ce1',/*还没用过这款聊天气泡你就OUT啦！下载搜狗输入法领取更多免费气泡*/
            imgurl:'//img.shouji.sogou.com/wapdl/hole/201909/27/2019092715103743468486.png',
            contenturl: '//shouji.sogou.com/interface/chatbubble'
        },
        weibo:{
            title:'\u7528\u597d\u770b\u7684\u804a\u5929\u6c14\u6ce1\u505a\u4eba\u7fa4\u91cc\u7684\u9753\u4ed4',
            content:'\u8fd8\u6ca1\u7528\u8fc7\u8fd9\u6b3e\u804a\u5929\u6c14\u6ce1\u4f60\u5c31\u004f\u0055\u0054\u5566\uff01\u4e0b\u8f7d\u641c\u72d7\u8f93\u5165\u6cd5\u9886\u53d6\u66f4\u591a\u514d\u8d39\u6c14\u6ce1',
            imgurl:'//img.shouji.sogou.com/wapdl/hole/201909/27/2019092715103743468486.png',
            contenturl: '//shouji.sogou.com/interface/chatbubble'
        },
        weixin:{
            title:'\u7528\u597d\u770b\u7684\u804a\u5929\u6c14\u6ce1\u505a\u4eba\u7fa4\u91cc\u7684\u9753\u4ed4',
            content:'\u8fd8\u6ca1\u7528\u8fc7\u8fd9\u6b3e\u804a\u5929\u6c14\u6ce1\u4f60\u5c31\u004f\u0055\u0054\u5566\uff01\u4e0b\u8f7d\u641c\u72d7\u8f93\u5165\u6cd5\u9886\u53d6\u66f4\u591a\u514d\u8d39\u6c14\u6ce1',
            imgurl:'//img.shouji.sogou.com/wapdl/hole/201909/27/2019092715103743468486.png',
            contenturl: '//shouji.sogou.com/interface/chatbubble'
        },
        sgapp:{
            title:'\u7528\u597d\u770b\u7684\u804a\u5929\u6c14\u6ce1\u505a\u4eba\u7fa4\u91cc\u7684\u9753\u4ed4',
            content:'\u8fd8\u6ca1\u7528\u8fc7\u8fd9\u6b3e\u804a\u5929\u6c14\u6ce1\u4f60\u5c31\u004f\u0055\u0054\u5566\uff01\u4e0b\u8f7d\u641c\u72d7\u8f93\u5165\u6cd5\u9886\u53d6\u66f4\u591a\u514d\u8d39\u6c14\u6ce1',
            imgurl:'//img.shouji.sogou.com/wapdl/hole/201909/27/2019092715103743468486.png',
            contenturl: '//shouji.sogou.com/interface/chatbubble'
        }
    }
};
var dataForShare = {
    title: shareConfig.default.weibo.title,
    content: shareConfig.default.weibo.content,
    imgurl: shareConfig.default.weibo.imgurl,
    contenturl: shareConfig.default.weibo.contenturl
}
var dataForWeixinShare = {
    title: shareConfig.default.weixin.title,
    content: shareConfig.default.weixin.content,
    imgurl: shareConfig.default.weixin.imgurl,
    contenturl: shareConfig.default.weixin.contenturl
}
var dataForAppShare = {
    title: shareConfig.default.sgapp.title,
    content: shareConfig.default.sgapp.content,
    imgurl: shareConfig.default.sgapp.imgurl,
    contenturl: shareConfig.default.sgapp.contenturl
}

function show_share(options) {
    var options = options || {};
    try{MtaH5.clickStat('share_btn_all')}catch(e){}
    if (isWeiXin()) {
        show_weixin_share();
        return true;
    }  else if (typeof window['SogouHotwordsUtils'] != 'undefined' && SogouHotwordsUtils.shareToApp) {
        share_sogouapp(options);
        return true;
    } else {
        share_weibo(options);
    }
}
var SHOW_WEIXIN_TIPER_TIMER;
function show_weixin_share() {
    $('#sharePopTiper').removeClass('shareWrap1 shareWrap2').addClass('shareWrap2').show();
    if (!SHOW_WEIXIN_TIPER_TIMER) {
        SHOW_WEIXIN_TIPER_TIMER = setTimeout(function(){
            $('#sharePopTiper').hide();
            SHOW_WEIXIN_TIPER_TIMER = null;
        }, 3000);
    }
    try{MtaH5.clickStat('share_weixin_btn')/*分享微信按钮*/}catch(e){}
}
function share_weibo(options) {
    var options = options || {};
    options = $.extend(false, {}, dataForShare, options);
    try{MtaH5.clickStat('share_weibo_btn')/*分享微博按钮*/}catch(e){}
    /*分享微博按钮*/
    var _t = options.content + ' ' + options.contenturl;
    window.open('http://v.t.sina.com.cn/share/share.php?title=' + encodeURIComponent(_t) + '&pic=' + encodeURIComponent(options.imgurl) + '&source=bookmark', '_blank', 'width=450,height=400');
}

function share_sogouapp(options) {
    var options = options || {};
    options = $.extend(false, {}, dataForAppShare, options);
    SogouHotwordsUtils.shareToApp(
        options.title,
        options.content,
        options.contenturl,
        options.imgurl
    );
    try{MtaH5.clickStat('share_sgapp_btn')/*APP内触发分享*/}catch(e){}
}

function reBindWxShare(options) {
    var options = options || {};
    options = $.extend(false, {}, dataForWeixinShare, options);
    var bindShareHandel = function() {
      if(bindShared) {
        bindShare(options);
      } else {
        setTimeout(bindShareHandel, 250);
      }
    }
    bindShareHandel();
}

var bindShared = false;
function bindShare(dataForShare) {
    var title = dataForShare.title;
    var desc = dataForShare.content;
    var link = dataForShare.contenturl;
    var imgUrl = dataForShare.imgurl;
    wx.onMenuShareTimeline({
        title: desc,
        link: link,
        imgUrl: imgUrl,
    });
    wx.onMenuShareAppMessage({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
    });
    wx.onMenuShareQQ({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
    });
    wx.onMenuShareWeibo({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
    });
    wx.onMenuShareQZone({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
    });
}

function initMeta() {
    var title = shareConfig.default.wap.title;
    var desc = shareConfig.default.wap.content;
    var imgUrl = shareConfig.default.wap.imgurl;
    var link = shareConfig.default.wap.contenturl;
    var metaStr = '' +
        '<meta property="og:type" content="' + title + '" />' +
        '<meta property="og:title" content="' + title + '" />' +
        '<meta name="keywords" content="' + title + '" />' +
        '<meta itemprop="name" content="' + title + '"/>' +
        '<meta name="description" itemprop="description" content="' + desc + '" />' +
        '<meta desc="' + desc + '" />' +
        '<meta name="desc" content="' + desc + '" />' +
        '<meta summary="' + desc + '" />' +
        '<meta name="summary" content="' + desc + '" />' +
        '<meta content="' + desc + '" />' +
        '<meta itemprop="image" content="' + imgUrl + '" />' +
        '<meta property="og:description" content="' + desc + '" />' +
        '<meta property="og:image" content="' + imgUrl + '" />' +
        '<meta property="og:url" content="' + link + '" />' +
        '<meta name="sharecontent" data-msg-img="' + imgUrl + '" data-msg-title="' + title + '" data-msg-content="' + desc + '" />'
    $("head").append(metaStr);
}

export function weixinInit (){
    initMeta();
    if (isWeiXin()) {
        appendscript('//res.wx.qq.com/open/js/jweixin-1.4.0.js', '', function () {
            appendscript('//shouji.sogou.com/api/weixin/jssdk/wxconfig.php?rurl=' + encodeURIComponent(document.location.href), '', function () {
                var wxconfig = window['wxconfig'] || '';
                if (wxconfig) {
                    wx.config({
                        appId: wxconfig.appId,
                        timestamp: wxconfig.timestamp,
                        nonceStr: wxconfig.nonceStr,
                        signature: wxconfig.signature,
                        jsApiList: [
                            'onMenuShareTimeline',
                            'onMenuShareAppMessage',
                            'onMenuShareQQ',
                            'onMenuShareWeibo',
                            'onMenuShareQZone'
                        ]
                    });
                    wx.ready(function () {
                        var title = dataForWeixinShare.title;
                        var desc = dataForWeixinShare.content;
                        var link = dataForWeixinShare.contenturl;
                        var imgUrl = dataForWeixinShare.imgurl;
                        if(imgUrl.substr(0, 4) != 'http') {
                            if(imgUrl.substr(0, 2) == '//') {
                                imgUrl = 'http:' + imgUrl;
                            } else {
                                imgUrl = 'http://' + imgUrl;
                            }
                        } else {
                            if(imgUrl.substr(0, 5) == 'https') {
                                imgUrl = 'http' + imgUrl.substr(5);
                            }
                        }
                        wx.onMenuShareTimeline({
                            title: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function(res) {},
                            cancel: function(res) {},
                            fail: function(res) {}
                        });
                        wx.onMenuShareAppMessage({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function(res) {},
                            cancel: function(res) {},
                            fail: function(res) {}
                        });
                        wx.onMenuShareQQ({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function(res) {},
                            cancel: function(res) {},
                            fail: function(res) {}
                        });
                        wx.onMenuShareWeibo({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function(res) {},
                            cancel: function(res) {},
                            fail: function(res) {}
                        });
                        wx.onMenuShareQZone({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function(res) {},
                            cancel: function(res) {},
                            fail: function(res) {}
                        });
                        // bindShare(dataForWeixinShare);
                        // bindShared = true;
                    });
                }
            });
        });
    }
}

